import { render, staticRenderFns } from "./_Indicadores.vue?vue&type=template&id=618f2f93&scoped=true&"
import script from "./_Indicadores.vue?vue&type=script&lang=js&"
export * from "./_Indicadores.vue?vue&type=script&lang=js&"
import style0 from "./_Indicadores.vue?vue&type=style&index=0&id=618f2f93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618f2f93",
  null
  
)

export default component.exports